import React from 'react';
import './Footer.css';

const Footer = ({ handleLoginClick }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Home</h4>
            <p>+19033531539</p>
          
            <p><strong>Sales Inquiries:</strong></p>
            <p><strong>support@cluservicesco.com</strong></p>
          </div>
          
          <div className="footer-section">
            <h4>Contact Us</h4>
            <p>+19033531539</p>
          
            <p><strong>Sales Inquiries:</strong></p>
            <p><strong>support@cluservicesco.com</strong></p>
            <p>905 US Highway 79 N</p>
            <p>Henderson, TX 75652-6111</p>
          </div>
          
          <div className="footer-section">
            <h4>Online Portal</h4>
            <p>
              <button className="footer-link" onClick={handleLoginClick}>Log In</button> | 
              <button className="footer-link" onClick={handleLoginClick}>Sign Up</button>
            </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-legal">
          
            <p>&copy; All Rights Reserved.</p>
            <p>Carmel Lahaina Utility Services</p>
           
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
